<!--
 * @Author: Merlin
 * @Date: 2024-04-01 16:27:49
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-01 15:22:04
 * @Description: 用处说明：
    各个游戏界面都有【规则】按钮，点击后将弹出窗口，此窗口上方的页签此是此组件 
-->

<template>
    <ul class="bar-wrap" 
        :class="{'mobile-mode': isSmallScreen}"
    >
        <li v-for="(oCur, idx) of (tabList as any)"
            :key="idx"
            class="tabs__btn"
            :class="{
                'tabs__btn_active': modelValue === oCur.label,
            }"
            @click="clickTab(oCur)"
        >
            <template v-if="oCur.icon" >
                <IconSvgUse 
                    width="18" 
                    height="18" 
                    :use="oCur.icon" 
                />
                &nbsp;
            </template>
            {{ $t(oCur.label) }}
        </li>
    </ul>
</template>

<script lang="ts" setup>
import useGlobalStore from '@/stores/global';
const oGlobalStore = useGlobalStore();

const props = defineProps({
    tabList: Array,
    modelValue: { // 当前标签 label 名称 
        type: String,
        default: '',
    },
});

// ↓ 值为 true 则需要将页签显示为2行
const isSmallScreen  =  computed(()=>{
    const {innerWidth} = oGlobalStore;
    const iWidth = props.tabList.length > 3 ? 530 : 480;
    const isSmallScreen = innerWidth <= iWidth; 
    return isSmallScreen;
});

const emit = defineEmits(['update:modelValue']);

function clickTab(oCur){
    const {label} = oCur;
    emit('update:modelValue', label);
}


</script>

<style scoped lang="scss">
.bar-wrap{
    display: flex;
    background-color: var(--color_grey-100);
    padding: 6px;
    width: 100%;
    border-radius: 100px;
}

// ↓ 移动端形态 
.bar-wrap.mobile-mode{
    border-radius: 3px;
    flex-flow: wrap;
    li{
        border-radius: 3px;
        margin: 0;
        min-width: 50%;
    }
}

.tabs__btn{
    background-color: transparent;
    color: var(--color_grey-20);
    flex: 1 1;
    font-size: 14px;
    font-weight: 600;
    justify-content: center;
    line-height: 18px;
    padding: 7px;
    transition: color .1s ease-in-out;
    align-items: center;
    display: flex;
    cursor: pointer; 
    border-radius: 100px;
    white-space: nowrap;
    &:hover {
        color: white;
    }
    & + *{
        margin-left: 8px;
    }
    &.tabs__btn_active{
        background-color: var(--color_blue);
        color: var(--color_white);
    }
}

</style>




